import { Card, Div, Flex, Icon } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'

type SelectableCardProps = {
  children?: React.ReactNode
  isActive: boolean
  onClick?: () => void
  shouldShowActiveIcons?: boolean
  backgroundColor?: string
  width?: string
}
export const SelectableCard: FC<SelectableCardProps> = ({
  isActive,
  children,
  onClick,
  shouldShowActiveIcons = true,
  backgroundColor,
  width = '100%',
}) => {
  return (
    <Div
      cursor="pointer"
      onClick={() => onClick?.()}
      width={width}
      backgroundColor={backgroundColor}
      borderRadius="default"
    >
      <Card
        overflow="hidden"
        boxShadow="mediumLight"
        borderRadius="default"
        width="100%"
        inset="x2"
        borderWidth={'default'}
        borderColor={
          isActive ? { swatch: 'success', shade: 'base' } : 'transparent'
        }
        borderStyle={isActive ? 'solid' : 'none'}
      >
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          {children}
          {shouldShowActiveIcons && (
            <Div
              backgroundColor={
                isActive
                  ? { swatch: 'success', shade: 'base' }
                  : { swatch: 'grayScale', shade: '_900' }
              }
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="24px"
              height="24px"
              borderRadius="small"
            >
              <Icon
                size="xSmall"
                name={isActive ? 'check' : 'add'}
                primaryColor="inverseBodyText"
              />
            </Div>
          )}
        </Flex>
      </Card>
    </Div>
  )
}
